<template>
  <div class="w-full mt-64">
    <div class="bg-main antialiased tracking-normal leading-loose">
      <div class="flex justify-center full-width bg-dark text-primary relative">
        <img
          :src="require('../assets/img/vnftLogo.svg')"
          class="h-48 absolute left-0 bottom-0 -mx-16 opacity-50"
        />

        <div
          class="py-16 w-4/5 items-center flex flex-col-reverse md:flex-row text-center sm:text-left md:justify-between md:-mx-4"
        >
          <div class="w-full md:w-1/2 md:px-4">
            <div class="text-primary text-2xl mb-2">gallery.VeryNifty.io</div>

            <div class="mb-2 text-xs pr-6">
              The VeryNifty Gallery is an experimental game and currently in
              beta. Any risks you take using this platform are your own. This is
              not an investment vehicle. Caution is advised.
            </div>
            <div class="">
              <!-- <a
                href="https://twitter.com/niftymuseum"
                target="_blank"
                class="text-xl text-white hover:text-blue-400"
                >Twitter</a
              > -->
            </div>
          </div>
          <div class="md:w-2/3 -mx-4 md:flex text-md">
            <div class="w-full md:px-4">
              <ul class="list-reset">
                <li>
                  <a
                    href="https://docs.verynifty.io/"
                    target="_blank"
                    class="hover:text-white"
                    >Docs</a
                  >
                </li>
                <li>
                  <a href="https://discord.gg/kfByfux" class="hover:text-white"
                    >Discord</a
                  >
                </li>
                <li>
                  <a href="https://t.me/verynifty" class="hover:text-white"
                    >Telegram</a
                  >
                </li>

                <li>
                  <a
                    href="https://twitter.com/niftymuseum"
                    target="_blank"
                    class="hover:text-white"
                    >Twitter</a
                  >
                </li>
                <li>
                  <router-link to="/calc">Calculate Rewards</router-link>
                </li>
                <li>
                  <router-link to="/killerboard">Killerboard</router-link>
                </li>
              </ul>
            </div>
            <div class="w-full md:px-4">
              <ul class="list-reset">
                <li>
                  <a
                    href="https://etherscan.io/address/0x57f0B53926dd62f2E26bc40B30140AbEA474DA94"
                    class="hover:text-white"
                    target="_blank"
                    >vNFT Contract</a
                  >
                </li>

                <li>
                  <a
                    href="https://etherscan.io/address/0x45d3a7a9ed477a1B3351175b2868CE3D39502D35"
                    class="hover:text-white"
                    target="_blank"
                    >StakeForVnfts Contract</a
                  >
                </li>
                <li>
                  <a
                    href="https://etherscan.io/address/0xB6Ca7399B4F9CA56FC27cBfF44F4d2e4Eef1fc81"
                    class="hover:text-white"
                    target="_blank"
                    >MuseToken Contract</a
                  >
                </li>
                <li>
                  <router-link to="/care-taker" class="hover:text-white"
                    >Care Taker</router-link
                  >
                </li>
                <li>
                  <router-link to="/branding" class="hover:text-white"
                    >Branding</router-link
                  >
                </li>
                <li>
                  <router-link to="/lottery" class="hover:text-white"
                    >Lottery</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  components: {},
  props: {},
  data: function () {
    return {};
  },
  methods: {},
  beforeMount: function () {},
  watch: {},
  computed: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
